import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isToday } from 'date-fns'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { Alert } from 'ui'
import { closeModal, openModal } from 'store/actions/modals'
import PunchService, { punchCardRequiresComment } from 'services/PunchService'
import { getLocale, Parse } from 'services/Dates'
import { getDevicePosition, getPermissionStatus } from 'services/geoUtils'

import { t } from 'translations'

const PunchInOutModalGeolocation = ({ event, punchingIn }) => {
  const dispatch = useDispatch()

  const { userInfo } = useSelector(state => state.users)
  const { enablePunchComment, requireEmployeeLocation } = useSelector(state => state.settings)
  const [isSubmitting, setIsSubmitting] = useState()
  const locale = getLocale(userInfo.language)

  const notToday = !isToday(Parse(event.start))

  const confirmPunch = async () => {
    setIsSubmitting(true)
    const permission = await getPermissionStatus()
    if (permission === 'denied' && requireEmployeeLocation) {
      setIsSubmitting(false)
      alert(t('employee.punch.ENABLE_LOCATION_SERVICES'))
      return
    }
    if (permission === 'prompt') {
      setIsSubmitting(false)
      dispatch(closeModal())
      dispatch(openModal('GeolocationRequestModal', { event }))
      return
    }
    const geoLocation = await getDevicePosition()
    const punchCard = await PunchService.punch(event._id, userInfo, geoLocation)
    setIsSubmitting()
    dispatch(closeModal())

    // Offer to add comment for the manager if the employee isInLate, isInEarly, isOutEarly or isOutLate
    if (punchCardRequiresComment(punchCard) && enablePunchComment) dispatch(openModal('PunchAddCommentModal', { punchCard, locale }))
  }

  return (
    <BaseModal hideButtons title={`employee.punch.PUNCH_${punchingIn ? 'IN' : 'OUT'}_MODAL`}>
      <Alert variant="warning" className="mt-2" show={!!punchingIn && notToday}>
        {t('employee.punch.WRONG_DAY')}
      </Alert>
      <div className="mt-2">
        <Button text="actions.CONFIRM" isSubmitting={isSubmitting} className="btn btn-primary mr-2" onClick={() => confirmPunch()} />
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default PunchInOutModalGeolocation
